function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './TimelineNavigationCompact.css';
import React from 'react';
// import { get, JssField, injectImageResolution, pathJoin, getMediaHost, getDictionaryItem, DictionaryProps, } from '../../utils';
import { get, getDictionaryItem } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { tealiumClickFunc, tealiumMergeClickData } from "../../utils/tealium";
export const TimelineNavigationCompact = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const activeItemId = get(fields, 'data.item.activeItemId');
  const daysNavAnalytics = get(fields, 'data.daysNavAnalytics');
  const values = get(fields, 'data.item.days.values');
  const dictionary = get(fields, 'data.dictionary');
  const day = getDictionaryItem(dictionary, 'Day');
  const renderItems = () => {
    if (values) {
      let newValue = values;
      /* if (rtl) {
        newValue = values.slice(0).reverse();
      } */
      const notRouterLinksCondProps = {
        tabIndex: -1
      };
      return newValue.map((item, index) => {
        const id = get(item, 'id');
        const url = get(item, 'url');
        return /*#__PURE__*/React.createElement("a", _extends({
          key: index,
          "data-id": id,
          className: `timeline-event-navigation__list ${activeItemId === id ? 'timeline-event-navigation__list--active' : ''}`,
          href: url,
          "aria-label": "Days",
          onClick: () => tealiumClickFunc(tealiumMergeClickData(daysNavAnalytics, params), item.name)
        }, notRouterLinksCondProps), day.replace('{day}', `${index + 1}`));
      });
    }
    return [];
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeline"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeline-event-navigation-wrapper"
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      state
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "timeline-event-navigation__arrow-left"
    }, renderPreviousButton()), /*#__PURE__*/React.createElement("div", {
      className: `timeline-event-navigation ${get(state, 'slidesToShow') >= get(state, 'totalItems') ? 'timeline-event-navigation-center' : ''}`
    }, renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 1441
          },
          items: 7
        },
        tabletLarge: {
          breakpoint: {
            max: 1440,
            min: 769
          },
          items: 7
        },
        tabletMedium: {
          breakpoint: {
            max: 768,
            min: 600
          },
          items: 6
        },
        tablet: {
          breakpoint: {
            max: 599,
            min: 480
          },
          items: 5
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 4
        }
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "timeline-event-navigation__arrow-right"
    }, renderNextButton()));
  }))))));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref3;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: ` ${commonStyles} ${commonStylesFocus} ${rtl ? rtlStyles : ltrStyles} ${rtl ? rtlSpecific : ltrSpecific} `,
    componentTabIndex: "disabled"
  }, children);
};
export const commonStyles = "c98aymt";
export const ltrStyles = "lrvj5x7";
export const rtlStyles = "r1nwy4bz";
const commonStylesFocus = "cqpofpk";
const ltrSpecific = "l2mhmi";
const rtlSpecific = "rjqo6wu";
export default TimelineNavigationCompact;